
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2Model } from "../../model/Poker2Model";
import { InputFieldConstants } from "../constants/InputFieldConstants";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2FeedbackDialogProperties } from "./Poker2FeedbackDialogProperties";

import Container = createjs.Container;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;

export class Poker2FeedbackDialog extends Poker2Dialog {
    public static NAME: string = "PokerFeedbackDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected applyProperties(): void {
        this.feedbackReport.btn_ok.label = Poker2Model.languageData.getTextById("dialog_pesentreminder_send");
        this.feedbackReport.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_cancel");
        this.feedbackReport.txt_title.text = Poker2Model.languageData.getTextById("dialog_feedback_title");
        this.feedbackReport.input_text.text = Poker2Model.languageData.getTextById("dialog_feedback_copy");
        this.feedbackReport.input_text.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.feedbackReport.input_text.maxChars = 512;
    }

    public show(): void {
        this.feedbackReport.input_text.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusIn));
        this.feedbackReport.input_text.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOut));
        super.show();
    }

    public hide(): void {
        this.feedbackReport.input_text.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusIn));
        this.feedbackReport.input_text.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOut));
        super.hide();
    }

    private onFocusIn(event: FocusEvent): void {
        if (this.feedbackReport.input_text.text == Poker2Model.languageData.getTextById("dialog_feedback_copy")) {
            this.feedbackReport.input_text.text = "";
        }

        this.feedbackReport.input_text.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
    }

    private onFocusOut(event: FocusEvent): void {
        if (this.feedbackReport.input_text.text == "") {
            this.feedbackReport.input_text.text = Poker2Model.languageData.getTextById("dialog_feedback_copy");
            this.feedbackReport.input_text.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }
        else {
            this.feedbackReport.input_text.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.feedbackReport.btn_ok:
                this.onSend();
                break;
            case this.feedbackReport.btn_close:
            case this.feedbackReport.btn_cancle:
                this.hide();
                break;
        }
    }

    private onSend(): void {
        var text: string = this.feedbackReport.input_text.text;

        if (text != Poker2Model.languageData.getTextById("dialog_feedback_copy")) {
            var paramObject: any = { pid: Poker2Model.userData.playerID, msg: text };
            BasicModel.smartfoxClient.sendMessage("gfb", [JSON.stringify(paramObject)]);
            this.hide();
        }
    }

    protected get feedbackProperties(): Poker2FeedbackDialogProperties {
        return this.properties as Poker2FeedbackDialogProperties;
    }

    protected get feedbackReport(): Library.PokerInterface.PokerFeedback {
        return this.disp as Library.PokerInterface.PokerFeedback;
    }
}
